import { useContext } from 'react';

import { NotificationContext } from './NotificationContext';

export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      "useNotification hook can't be used outside of NotificationProvider"
    );
  }

  return context;
};
